jQuery(document).ready(function($) {

    // HDP
    var h1 = $(".bloc_hdp h1")
    var hdp = $(".bloc_hdp")
    var more = $(".bloc_hdp .more span")
    var filet = $(".bloc_hdp .more .filet")
    var detail = $(".bloc_hdp .accroche")

    gsap.set(hdp, { clipPath: 'circle(0% at 50% 50%)' })

    var hdpTL = gsap.timeline()

    if(hdp.length){
        hdpTL.to(hdp, {
            clipPath: 'circle(100% at 50% 50%)',
            duration : 1.1,
            ease: "power1.out",
        })
    }

    if(h1.length){
        hdpTL.from(h1, {
            opacity: 0,
            duration: 0.6,
            delay: 0.2,
            ease: "power1.out",
        })
    }

    if(detail.length) {
        hdpTL.from(detail, {
            opacity: 0,
            duration: 0.6,
            delay: 0.2,
            ease: "power1.out",
        })
    }


    if(filet.length) {
        hdpTL.from(filet, {
            height: 0,
            duration: 0.4,
            delay: 0,
            ease: "power1.out",
        })
    }

    if(more.length) {
        hdpTL.from(more, {
            opacity: 0,
            duration: 0.4,
            delay: 0,
            ease: "power1.out",
        })
    }


});